import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useUIStore } from "../../../../store";
import { IconLightDark, IconSearch } from "../../../atoms";
import styles from "./Navbar.module.scss";

interface Props {
  restaurantName: string;
}

export const Navbar = ({ restaurantName }: Props) => {
  const isSticky = useUIStore((s) => s.isSticky);
  const config = useUIStore((s) => s.config);
  const demoLogo = useUIStore((s) => s.demoLogo);

  const [params] = useSearchParams();

  const localName = (params.get("name") ?? "").trim() || restaurantName;
  const localColor = params.get("color");
  const logoParam = params.get("logo");
  const logoSrc = demoLogo ?? logoParam ?? null;

  const headerImageUrl = (config as any).header_image_url as string | null | undefined;
  const imagesVersion = config.imagesVersion;

  const headerBg = headerImageUrl?.trim()
    ? `${headerImageUrl.trim()}${headerImageUrl.includes("?") ? "&" : "?"}v=${imagesVersion || "1"}`
    : null;

  const navbarStyle = useMemo(() => {
    if (isSticky) return undefined;
    if (localColor) return { backgroundColor: localColor };
    if (headerBg) {
      return {
        backgroundImage: `url(${headerBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    }
    return undefined;
  }, [isSticky, localColor, headerBg]);

  return (
    <nav
      className={`${styles.containerNavbar} ${isSticky ? styles.navbarSticky : ""}`}
      style={navbarStyle}
    >
      <div className={styles.brand}>

        {isSticky ? (
          <div className={styles.brand}>
            <p className={styles.title}>{localName}</p>
          </div>
        ) : (
          logoSrc ? (
            <img src={logoSrc} className={styles.logo} alt={localName} />
          ) : (
            <p className={styles.title}>{localName}</p>
          )
        )}
      </div>

      <div className={styles.containerIconLightDarkSearch}>
        {!isSticky && <IconLightDark />}
        <IconSearch />
      </div>
    </nav>
  );
};